import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from './layouts/AppLayout';
import Dashboard from './pages/Dashboard';
import Patients from './pages/Patients';
import Appointments from './pages/Appointments';
import Settings from './pages/Settings';
import CarePlans from './pages/CarePlans';
import Billing from './pages/Billing';
import AuditLog from './pages/AuditLog';
import Login from './pages/Login';
import { Role, useAuth } from './state/AuthContext';
import RoleGate from './components/RoleGate';
import './styles/globals.css';

interface RouteConfig {
  path: string;
  element: React.ReactNode;
  roles: Role[];
}

const routes: RouteConfig[] = [
  {
    path: '/',
    element: <Dashboard />,
    roles: ['medical_director', 'surgery', 'internal_med', 'customer_service', 'billing'],
  },
  {
    path: '/patients',
    element: <Patients />,
    roles: ['medical_director', 'surgery', 'internal_med'],
  },
  {
    path: '/care',
    element: <CarePlans />,
    roles: ['medical_director', 'surgery', 'internal_med'],
  },
  {
    path: '/appointments',
    element: <Appointments />,
    roles: ['medical_director', 'surgery', 'internal_med', 'customer_service'],
  },
  {
    path: '/billing',
    element: <Billing />,
    roles: ['medical_director', 'billing', 'customer_service'],
  },
  {
    path: '/audit',
    element: <AuditLog />,
    roles: ['medical_director', 'billing'],
  },
  {
    path: '/settings',
    element: <Settings />,
    roles: ['medical_director'],
  },
];

const App: React.FC = () => {
  const { isAuthenticated, status } = useAuth();

  if (status === 'initializing') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-100 text-slate-500">
        Preparing console…
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        {isAuthenticated ? (
          <>
            <Route element={<AppLayout />}>
              {routes.map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={<RoleGate allowedRoles={route.roles}>{route.element}</RoleGate>}
                />
              ))}
            </Route>
            <Route path="/login" element={<Navigate to="/" replace />} />
          </>
        ) : (
          <>
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )}
      </Routes>
    </Router>
  );
};

export default App;
